/* Swap this object to re-skin the whole page; nothing else needs to change. */
const data = {
  name: "Diego Cancho",
  role: "Software Developer",
  location: "Lima · remote",
  bio: "I build client products end-to-end - commerce backends, credential platforms, integrations - and spend what's left thinking about design systems and AI agents.",
  links: [
    { label: "me@diegocancho.dev", href: "mailto:me@diegocancho.dev", kind: "email" },
    { label: "github.com/dcancho", href: "https://github.com/dcancho", kind: "ext" },
    { label: "linkedin.com/in/dcanchoc", href: "https://linkedin.com/in/dcanchoc", kind: "ext" },
  ],
  experience: [
    {
      role: "Junior Software Developer",
      company: "Bertoni Solutions",
      note: "software consultancy",
      dates: "Feb 2025 - Present",
      summary: "Backend and full-stack delivery across two concurrent client projects.",
      bullets: [
        "Built and extended the backend for an international retail e-commerce platform, NopCommerce on .NET, deployed to Azure.",
        "Contributed to a cross-border academic credentials platform: ABP framework, Angular front-end, .NET backend.",
        "Shipping for clients outside Peru on both projects simultaneously.",
      ],
      stack: ["C#", ".NET", "NopCommerce", "ABP.io", "Angular", "Azure"],
    },
    {
      role: "Software Developer Intern",
      company: "Bertoni Solutions",
      note: "software consultancy",
      dates: "Aug 2024 - Jan 2025",
      summary: "Delivered the company's public web presence end-to-end.",
      bullets: [
        "Built the company webpage with HubSpot CMS, CRM workflows, third-party integrations, full marketing stack.",
        "First professional engagement; owned the technical side independently from brief to launch.",
      ],
      stack: ["HubSpot", "JavaScript", "HTML", "CSS"],
    },
  ],
  projects: [
    {
      name: "Design Foundry",
      tagline: "A DesignOps platform for design governance and system management.",
      meta: "in progress",
      stack: ["Design Systems", "DesignOps"],
      icon: "layers",
    },
    {
      name: "Global Azure Peru 2025",
      tagline: "Organized the Peruvian chapter of the worldwide Azure community conference.",
      meta: "event · 2025",
      stack: ["Azure", "Community"],
      icon: "calendar",
    },
    {
      name: "Research paper",
      tagline: "GPT-4o Based Multiagent Web System For Automated Generation Of Cross Platform Design Systems for Micro, Small and Medium-sized Enterprises",
      meta: "IEEE · 2026",
      stack: [],
      icon: "file-text",
      featured: true,
      href: "https://doi.org/10.1109/CSECS69124.2026.11541621",
    },
  ],
  skills: [
    { group: "Languages", items: ["C#", "TypeScript", "Python"] },
    { group: "Platforms", items: [".NET", "Angular", "ABP.io", "NopCommerce"] },
    { group: "Infra & Tools", items: ["Azure", "Figma", "Microsoft Foundry"] },
    { group: "Interests", items: ["Design Systems", "AI Agents", "Interaction"] },
  ],
  education: [
    { what: "B.Sc. Software Engineering", where: "UPC", dates: "2021 - 2026 · in progress" },
  ],
};

export default data;
